import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/content/InterestCapture.tsx");
